import { render, staticRenderFns } from "./NoLimitBoard.vue?vue&type=template&id=680f2f0a&scoped=true&"
import script from "./NoLimitBoard.vue?vue&type=script&lang=js&"
export * from "./NoLimitBoard.vue?vue&type=script&lang=js&"
import style0 from "./NoLimitBoard.vue?vue&type=style&index=0&id=680f2f0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f2f0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFlex,VImg,VRow})
